module.exports = __webpack_public_path__ + "img/heat-cost-allocator-lg.c5f78abb.svg";